import React, { FC, CSSProperties } from "react"
import styled from "styled-components"
import { toRem } from "../../../utils/styles-function"
import lockIcon from "../../../static/icons/lock.svg"

const LockIcon: FC = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0007 1C7.70315 1 5.83398 2.86917 5.83398 5.16667V6.83333H5.00065C4.08148 6.83333 3.33398 7.58083 3.33398 8.5V16C3.33398 16.9192 4.08148 17.6667 5.00065 17.6667H15.0007C15.9198 17.6667 16.6673 16.9192 16.6673 16V8.5C16.6673 7.58083 15.9198 6.83333 15.0007 6.83333H14.1673V5.16667C14.1673 2.86917 12.2982 1 10.0007 1ZM7.50065 5.16667C7.50065 3.78833 8.62232 2.66667 10.0007 2.66667C11.379 2.66667 12.5007 3.78833 12.5007 5.16667V6.83333H7.50065V5.16667ZM15.0023 16H10.834V14.1017C11.3298 13.8125 11.6673 13.2808 11.6673 12.6667C11.6673 11.7475 10.9198 11 10.0007 11C9.08148 11 8.33398 11.7475 8.33398 12.6667C8.33398 13.28 8.67148 13.8125 9.16732 14.1017V16H5.00065V8.5H15.0007L15.0023 16Z"
      fill="white"
    />
  </svg>
)

const ButtonStyle = styled.a`
  button {
    background: #cdd2d6;
    color: white;
    font-size: ${toRem(16)};
    line-height: ${toRem(24)};
    font-weight: 600;
    border: none;
    border-radius: 3px;
    padding: 12px 28px;
    cursor: pointer;
    transition: 0.225s ease;

    &::before {
      content: url("${lockIcon}");
      position: relative;
      right: 6px;
      top: 5px;
    }

    &:hover {
      background: #00d900;
    }

    &:active {
      background: #15a144;
    }

    &:disabled {
      opacity: 0.4;
    }
  }
`

interface IButton {
  to?: string
  disabled?: boolean
  style?: CSSProperties
}

const ActivateCabinetButton: FC<IButton> = ({ children, to, ...rest }) => {
  return (
    <ButtonStyle href={to}>
      <button {...rest}>{children}</button>
    </ButtonStyle>
  )
}

export default ActivateCabinetButton
